/**
 * Clear storage if stored refresh token has expired (issuedAt+expiresIn < now).
 * @param  {string} [storageType='localStorage']  - e.g. localStorage or sessionStorage.
 * @param  {any} persistConfig - redux-persist configuration object.
 * @return {void}
 */
const onExpiredTokens = (storageType = 'localStorage', persistConfig) => {
    // If tokens expired --> empty localStorage before rehydration occurs.
    // Alternative: use sessionStorage.
    const storageKey = `persist:${persistConfig.key}`
    const emptyStorage = () => window[storageType][storageKey] = ""
    try {
        let lsStore, oidc, expires
    
        // Check 1 - Stored app state?
        if(window[storageType] && window[storageType][storageKey]) lsStore = JSON.parse(window[storageType][storageKey])
        else{
            console.log('')
            return // No state stored.
        }

        // Check 2 - oidc obj in stored app state?
        if(lsStore.oidc) oidc = JSON.parse(lsStore.oidc)
        else {
            emptyStorage()
            return
        }
        
        // Check 3 - oidc contains needed values to full authentication?
        if(oidc && oidc.issuedAt && oidc.expiresIn && oidc.refreshToken && oidc.accessToken){
            expires = (+oidc.issuedAt + +oidc.expiresIn)*1000 // s to ms
            // Check 3.1 - oidc parameters correct type?
            if(typeof expires !== 'number' || isNaN(expires) || expires + 1000*60 <= Date.now()){ // 1000*60 = 1 min in milliseconds.
                console.log('Session expired. Resetting storage.')
                emptyStorage()
            }
            else {
                console.log('')
                // Nothing, leave storage as it is.
            }
        }
        else {
            // Nothing, leave storage as it is.
            
            console.log('Unable to restore session on page refresh. Resetting storage.')
            emptyStorage()
            return
        }
    } catch (error) {
            console.log('Unexpected error: Unable to restore session. Resetting storage.')
            emptyStorage()
            return
    }
}

const handleStorage = {onExpiredTokens}
export default handleStorage